var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(!_vm.loaded)?_c('MountainBox',[_c('Logo'),_c('p',[_vm._v(_vm._s(_vm.$t('loadingApp')))])],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }